import { render, staticRenderFns } from "./TgProfitDialog.vue?vue&type=template&id=f75e807e"
import script from "./TgProfitDialog.vue?vue&type=script&lang=js"
export * from "./TgProfitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports